export const Locale = {
  ERROR: {
    NETWORK_FAILURE: "Something went wrong, please try again later.",
    403: "ERROR:403 - Access to the requested resource is forbidden.",
    401: "Session Expired, Please login again",
    // 401: "ERROR 401 - Authorization Required, please login again.",
    400: "ERROR 400 - Bad Request: The server can’t return a response.",
    404: "ERROR 404 - The requested resource was not found.",
    405: "ERROR 405 - Method not allowed.",
    409: "ERROR 409 - The server couldn’t process your browser’s request because there’s a conflict with the relevant resource.",
    413: "ERROR 413 - Payload Too Large.",
    500: "ERROR 500 - There was an error on the server and the request could not be completed.",
    OFFLINE: "You are not connected to internet."
  },
  INFO: {
    ONLINE: "You are connected to internet."
  }
}
